import { axios } from '@/services/axios';

export const updateTRSRegistration = (data, requiredScope) => {
    const endpoint = '/TRSRegistration';
    return axios.put(endpoint, data, {
        headers: {
            'X-RequestScope': requiredScope,
        },
    });
};
